<script setup lang="ts">
import { storeToRefs } from 'pinia'

defineProps<{ critical: boolean }>()

const authStore = useAuthStore()
const site = useSite()
const route = useRoute()
const { t } = useLocale()

const isMobile = inject<Ref<boolean>>('isMobile')
const { isUserLogged } = storeToRefs(authStore)

const mustShowRegisBanner = computed(() => {
  if (route.path !== '/') return false
  return !isMobile?.value && !isUserLogged.value
})

const hasSecuritiConsent = inject<Ref<boolean>>('hasSecuritiConsentKey')
</script>

<template>
  <ClientOnly>
    <FooterRegisBanner v-if="mustShowRegisBanner" />
  </ClientOnly>
  <footer
    data-test="mcd-footer"
    class="grid gap-10 bg-mcd-secondaryIvory px-4 py-10 md:grid-cols-5 md:gap-5 md:px-14 md:pb-36 md:pt-20 md:text-xs"
  >
    <figure class="flex w-full md:col-span-1 md:justify-start md:place-self-start">
      <img :src="site.footer?.footerLogo.url" alt="McDonald's logo" />
    </figure>

    <section
      class="flex w-full flex-col gap-10 md:col-span-3 md:col-start-3 md:grid md:grid-cols-3"
    >
      <FooterCategories :block="site.footer?.footerSections" />
      <FooterCategoriesSocial :block="site.footer?.footerSectionsSocial" />
    </section>

    <div
      class="w-full border-b-2 border-solid border-slate-500 md:col-span-5 md:mt-24 md:h-auto"
    ></div>

    <section
      data-test="mcd-footer__legal-brand"
      class="flex w-full flex-col gap-5 md:col-span-5 md:grid md:grid-cols-5 md:pb-4 md:pt-5"
    >
      <div
        class="text-sm leading-4 tracking-[-0.15px] md:col-span-2 md:col-start-1 md:row-start-1 md:w-full md:justify-start"
      >
        {{ site.footer?.legalBrand.brand }}
      </div>

      <div
        class="flex flex-col gap-5 text-sm leading-4 tracking-[-0.15px] md:col-span-2 md:col-start-4 md:w-full md:flex-row md:justify-end"
      >
        <SimpleLink :link="site.footer?.legalBrand.privacy">
          <span>{{ site.footer?.legalBrand.privacy?.title }}</span>
        </SimpleLink>
        <SimpleLink :link="site.footer?.legalBrand.legal">
          <span>{{ site.footer?.legalBrand.legal?.title }}</span>
        </SimpleLink>

        <button
          v-if="hasSecuritiConsent"
          type="button"
          class="cmp-revoke-consent relative bottom-auto left-auto p-0 max-[765px]:ml-0 max-[765px]:mr-auto max-[765px]:block max-[765px]:text-left"
        >
          {{ t('footer.legalBrand.cookiePreferences') }}
        </button>
      </div>
    </section>
  </footer>
</template>
